import { useCallback } from 'react';
import { NavigateOptions, useNavigate } from 'react-router-dom';
import { useProjectSiteParams } from './use-project-site-params';

export const useProjectSiteNavigation = () => {
  const navigate = useNavigate();
  const { projectSlug, siteSlug, projectId, siteId } = useProjectSiteParams();

  const replaceParams = useCallback((path: string, pSlug: string, sSlug: string): string => {
    return path.replace(':projectId', pSlug).replace(':siteId', sSlug);
  }, []);

  const buildContextPath = useCallback((path: string, pSlug: string, sSlug: string): string => {
    const cleanPath = path.startsWith('/') ? path.slice(1) : path;
    return `/${pSlug}/${sSlug}/${cleanPath}`;
  }, []);

  const buildPath = useCallback(
    (path: string) => {
      if (!projectSlug || !siteSlug) return path;

      const hasParams = path.includes(':projectId') && path.includes(':siteId');
      return hasParams ? replaceParams(path, projectSlug, siteSlug) : buildContextPath(path, projectSlug, siteSlug);
    },
    [projectSlug, siteSlug, replaceParams, buildContextPath]
  );

  const navigateWithContext = useCallback(
    (path: string, options?: NavigateOptions) => {
      if (!projectSlug || !siteSlug) {
        navigate('/', options);
        return;
      }

      navigate(buildPath(path), options);
    },
    [navigate, projectSlug, siteSlug, buildPath]
  );

  return {
    navigateWithContext,
    buildPath,
    projectId,
    siteId,
    projectSlug,
    siteSlug
  };
};
